<div id="bellnotification" data-toggle="dropdown" aria-label="Notifications" title="Notifications" (click)="onclickBellNotificationDropdown()">
    <div class="bell-notification-toggler" data-toggle="dropdown" style="padding: 0px" (click)="onclickBellNotificationDropdown()">
        <div>
            <span id="bellnotificationIcon" class="fa fa-bell bell-notification-icon"
                  [ngStyle]="{'color': bellNotficationService.bellNotifications.length > 0 ? (bellNotficationService.hasNewNotification ? '#DA212C' : '#004F83') : '#90939F'}">
            </span>
            <span class="badge badge-primary badge-pill" *ngIf="bellNotficationService.bellNotifications.length > 0" style="vertical-align: top;">{{bellNotficationService.bellNotifications.length}}</span>
        </div>
        <div class="bell-notification-progress-bar progress-bar" role="progressbar" *ngIf="bellNotficationService.hasPendingBellNotification()"></div>
    </div>

    <div class="dropdown-menu bell-notification-dropdown-menu" [ngClass]="{mobileMenu: isMobile}">
        @for (notification of bellNotficationService.bellNotifications; track notification.BellNotificationID) {
        <li>
            <div style="width: 100%; height: 80px; display: inline-flex; padding-right: 5px; ">
                <button type="button"
                        class="bell-notification-tile"
                        style="grid-column: 1;"
                        [ngStyle]="{'background-color': notification.Status == 2 ? '#FBD4D7' : '' }"
                        [disabled]="notification.Status == 0"
                        (click)="executeActionURL($event, notification)">
                    <span class="bell-notification-tile-label" style="grid-row: 1; font-size: 16px;">{{notification.Title ?? ''}}</span>
                    <span class="bell-notification-tile-label" style="grid-row: 2; font-size: 14px;">{{notification.Description ?? ''}}</span>

                    <div class="progress" *ngIf="notification.Progress != null">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': notification.Progress + '%' }">{{notification.Progress}}%</div>
                     </div>

                    <div style="grid-row: 4; display: grid">
                        <span style="grid-column: 1 / 7; font-size: 12px;">{{notification.DateCompleted ?? notification.DateStarted | date: dateFormat}}</span>
                        <div class="bell-notification-tile-status" *ngIf="notification.Status == 0" style="grid-column: 8;">Processing</div>
                        <div class="bell-notification-tile-status" *ngIf="notification.Status == 1" style="grid-column: 8; color: #349C44; ">Ready</div>
                        <div class="bell-notification-tile-status" *ngIf="notification.Status == 2" style="grid-column: 8; color: #DA212C; ">Error</div>
                        <div class="bell-notification-tile-status" *ngIf="notification.Status == 3" style="grid-column: 8;">Enqueued</div>
                        <div class="bell-notification-tile-status" *ngIf="notification.Status == 4" style="grid-column: 8; color: #F89406; ">Warning</div>
                    </div>
                </button>
                <button class="fa fa-close bell-notification-tile-button" aria-label="Dismiss Notification" title="Dismiss Notification" style="grid-column: 2;" (click)="dismissBellNotification($event, notification.BellNotificationID)"></button>
            </div>
        </li>
        } @empty {
            <li><strong>No New Notifications</strong></li>
        }
    </div>
</div>
